var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({attrs:{"color":_vm.color(_vm.nomina.estado_masivo),"outlined":_vm.outlined(_vm.nomina.estado_masivo),"dark":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label(_vm.nomina.estado_masivo))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }